
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import '~@styles/vars'; // alias効かない？
  @import '~@/assets/styles/vars';

  header {
    // @extend .t-pink;
    font-family: $ff_basic;
    width: 100%;
    // height: 100px;
    text-align: center;
  }
  .inner {
    margin: 5px auto;
  }
  .logo {
    width: 150px;
  }

</style>

<template>
  <header class="u-mb-md">
    <div class="inner">
      <router-link to="/">
        <img src="../assets/images/logo.png" class="logo">
      </router-link>
      <section class="t-white-s">
        <h1>{{title}}</h1>
        <h4>-{{version}}-</h4>
      </section>
    </div>
    <global-nav></global-nav>
  </header>
</template>

<script>
import {SITE_NAME, SITE_VER} from '@/Const';
import globalNav from '@/components/GlobalNav';

export default {
  name: 'pxb-header',
  components: {
    globalNav,
  },
  data () {
    return {
      title: SITE_NAME,
      version: SITE_VER
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/Header.vue